(function () {
    'use strict';

    angular
        .module('app')
        .factory('Entity', EntityFactory);

    EntityFactory.$inject = [
        '$q',
        'EntitiesService',
        'EntityTemplatesService',
        'EntityFieldScalar',
        'EntityFieldEmbeddedEntity',
        'EntityFieldArray',
        'EntityFieldImage'];

    function EntityFactory(
        $q,
        EntitiesService,
        EntityTemplatesService,
        EntityFieldScalar,
        EntityFieldEmbeddedEntity,
        EntityFieldArray,
        EntityFieldImage) {

        /**
         * @constructor
         * @name Entity
         */
        function Entity() {
            this.Id = null;
            this.EntityTemplateId = null;
            this.Fields = [];
            this.LastUpdated = null;
            this.PreviewNameText = '';
            this.PreviewDescriptionText = '';
            this.EmailAddress = '';
        }

        Entity.convertEntity1toEntity2 = convertEntity1toEntity2;
        Entity.get = get;


        /**
         * Get the entity with the specified id.
         *
         * @return {promise} A promise that resolves an {entity} if successfully retrieved.
         *                   Rejects with an error response or message if an error occurred.
         */
        function get(id) {
            return $q.all({
                rootEntity: EntitiesService.get(id),
                entityTemplates: EntityTemplatesService.query()
            }).then(getDataOk);

            function getDataOk(data) {
                return convertEntity1toEntity2(data.rootEntity, data.entityTemplates.EntityTemplates);
            }
        }


        /**
         * Convert the entity to a 'value object'. An entity 'value object' representation excludes entity template information
         * from the field list.
         *
         * A 'value object' is the same format as 'Entity 1.0' object, and is optimised for transfer because of its compact size.
         */
        Entity.prototype.toValueObject = function () {
            return {
                Id: this.Id,
                EntityTemplateId: this.EntityTemplateId,
                EntityTemplate: this.EntityTemplate,
                Fields: entityFieldsToValueObject(this.Fields),
                LastUpdated: this.LastUpdated,
                PreviewNameText: this.PreviewNameText,
                PreviewDescriptionText: this.PreviewDescriptionText,
                EmailAddress: this.EmailAddress
            };
        };

        /**
         * Get field at the specified path on the entity.
         *
         * @param {string} entityPath - An expression in EntityPath/EPath format, e.g. 'Pets[1].Name'. Case-sensitive.
         * @return {EntityFieldScalar|EntityFieldArray} The field at the specified path, or null if no field exists at the path.
         *         If the field has a null/undefined value, a field object will still be returned, but its .value property will
         *         be null.
         */
        Entity.prototype.query = function (entityPath) {
            var i;

            var pathSegments = parseEntityPath(entityPath);
            var queryTarget = this;
            var queryResult = null;

            for (var segmentIndex = 0; segmentIndex < pathSegments.length; segmentIndex++) {
                var segment = pathSegments[segmentIndex];

                for (i = 0; i < queryTarget.Fields.length; i++) {
                    if (queryTarget.Fields[i].name === segment.key) {

                        if (segment.arrayIndex === null) {
                            queryResult = queryTarget.Fields[i];
                        } else {
                            if (queryTarget.Fields[i] instanceof EntityFieldArray) {
                                queryResult = queryTarget.Fields[i].value[segment.arrayIndex];
                            } else {
                                queryResult = null;
                            }
                        }

                        if (queryResult === undefined || queryResult === null) {
                            return null;
                        }

                        i = queryTarget.Fields.length;
                    }
                }

                if (segmentIndex < pathSegments.length - 1) {
                    if (queryResult instanceof Entity) {
                        throw 'Entity path query unexpectedly found Entity object instead of entity field';
                    } else if (queryResult instanceof EntityFieldEmbeddedEntity) {
                        queryTarget = queryResult.value;
                    } else {
                        // Though there are more segments to the path, they can't be reached because this isn't an embedded entity
                        return null;
                    }
                    queryResult = null;
                }
            }

            return queryResult;
        };

        /**
         * Override of object prototype toString function.
         */
        Entity.prototype.toString = function () {
            return '[object Entity]';
        };

        /**
         * Get an iterator for iterating the entity fields.
         * Function returns an object with the following properties:
         *     {EntityField} currentEntityField - The entity field for the current iterator position.
         *     {string} currentPath - The EntityPath/EPath for the current iterator position.
         *     {function} next() - Advance the iterator to the next field. Returns true if the iterator now points to a field.
         * 
         * When first created, the iterator does not point to a field, a call to next() is required.
         * e.g.
         * var iter = myEntity.getFieldIterator();
         * while (iter.next()) {
         *    // Do something with iter.currentEntityField
         * }
         */
        Entity.prototype.getFieldIterator = function () {
            var _entity = this;
            var _fields = [];
            var _fieldIndex = -1;

            function pushFields(fields, prefix) {
                if (prefix === undefined || prefix === null) {
                    prefix = '';
                }

                for (var i = 0; i < fields.length; i++) {
                    _fields.push({
                        path: prefix + fields[i].name,
                        value: fields[i]
                    });

                    if (fields[i] instanceof EntityFieldArray) {
                        for (var j = 0; j < fields[i].value.length; j++) {
                            _fields.push({
                                path: prefix + fields[i].value[j].name + '[' + j + ']',
                                value: fields[i].value[j]
                            });

                            if (fields[i].value[j] instanceof EntityFieldEmbeddedEntity) {
                                pushFields(fields[i].value[j].value.Fields, prefix + fields[i].value[j].name + '[' + j + '].');
                            }
                        }
                    } else if (fields[i] instanceof EntityFieldEmbeddedEntity) {
                        pushFields(fields[i].value.Fields, fields[i].name + '.');
                    }
                }
            }

            pushFields(_entity.Fields);

            var iterator = {};
            Object.defineProperty(iterator, 'currentEntityField', {
                get: function () {
                    return _fields[_fieldIndex].value;
                }
            });
            Object.defineProperty(iterator, 'currentPath', {
                get: function () {
                    return _fields[_fieldIndex].path;
                }
            });
            iterator.next = function () {
                _fieldIndex++;
                return _fieldIndex < _fields.length;
            };

            return iterator;
        };


        /**
         * Convert entity fields to a value-only format. I.e. instead of EntityField objects, just scalar values.
         *
         * @param {array} entityFields - Array of {EntityField} objects.
         * @return {object} A value-only representation of the entity fields.
         */
        function entityFieldsToValueObject(entityFields) {
            var obj = {};

            for (var i = 0; i < entityFields.length; i++) {
                if (entityFields[i] instanceof EntityFieldArray) {
                    obj[entityFields[i].name] = [];

                    for (var j = 0; j < entityFields[i].value.length; j++) {
                        if (entityFields[i].value[j] instanceof EntityFieldEmbeddedEntity) {
                            obj[entityFields[i].name].push(entityFieldsToValueObject(entityFields[i].value[j].value.Fields));
                        } else {
                            obj[entityFields[i].name].push(entityFields[i].value[j].value);
                        }
                    }
                } else if (entityFields[i] instanceof EntityFieldEmbeddedEntity) {
                    obj[entityFields[i].name] = entityFieldsToValueObject(entityFields[i].value.Fields);
                } else {
                    obj[entityFields[i].name] = entityFields[i].value;
                }
            }

            return obj;
        }

        /**
         * Parse an EntityPath/EPath expression into a list of segments.
         * Each segment represents a single field in an entity.
         * E.g.
         * Person.Pets[3].Name
         * will parse to 'Person', 'Pets[3]' and 'Name'
         *
         * @param {string} entityPath
         * @returns {Array} An order-sensitive list of segments for the provided path.
         *                  Each segment is represented by an object with the following properties:
         *                  {string} key - The field name, e.g. 'Pets'
         *                  {number} arrayIndex - The array index if referring to an element within
         *                           an array field, e.g. 3, otherwise null.
         */
        function parseEntityPath(entityPath) {
            var parseIndex = 0;
            var segmentBuffer = '';
            var currentChar;
            var pathSegments = [];

            function pushPathSegment(segment) {
                if (segment.startsWith("['")) {
                    segment = segment.substring(2);
                }

                if (segment.endsWith("']")) {
                    segment = segment.substring(0, segment.length - 2);
                }

                if (segment.indexOf('[') !== -1) {
                    var key = segment.substring(0, segment.indexOf('['));
                    var arrayIndex = segment.substring(segment.indexOf('[') + 1);
                    if (arrayIndex.endsWith(']')) {
                        arrayIndex = arrayIndex.substring(0, arrayIndex.length - 1);
                    }

                    pathSegments.push({
                        key: key,
                        arrayIndex: Number(arrayIndex)
                    });
                } else {
                    pathSegments.push({ key: segment, arrayIndex: null });
                }
            }

            while (parseIndex < entityPath.length) {
                currentChar = entityPath[parseIndex];

                switch (currentChar) {
                    case '.':
                        if (segmentBuffer.length > 0) {
                            pushPathSegment(segmentBuffer);
                            segmentBuffer = '';
                        }
                        break;

                    case '[':
                        if (parseIndex < entityPath.length - 1) {
                            parseIndex++;

                            if (entityPath[parseIndex] === "'") {
                                if (segmentBuffer.length > 0) {
                                    pushPathSegment(segmentBuffer);
                                }
                                segmentBuffer = "['";
                            } else {
                                segmentBuffer += '[' + entityPath[parseIndex];
                            }
                        }
                        break;

                    default:
                        segmentBuffer += currentChar;
                }

                parseIndex++;
            }

            if (segmentBuffer.length > 0) {
                pushPathSegment(segmentBuffer);
            }

            return pathSegments;
        }

        /**
         * Convert Entity 1.0 object to Entity 2.0 object.
         *
         * @param {Object} entity - An Entity 1.0 object.
         * @param {Array} entityTemplates - An array of EntityTemplate definitions.
         *
         * @return {Entity} An entity 2.0 object, converted from the input.
         */
        function convertEntity1toEntity2(entity, entityTemplates) {
            if (entity.EntityTemplateId === undefined || entity.EntityTemplateId === null) {
                if (entity.EntityTemplate === undefined || entity.EntityTemplate === null || entity.EntityTemplate.Id === undefined || entity.EntityTemplate.Id === null) {
                    throw 'No entity template ID specified on entity';
                }
                entity.EntityTemplateId = entity.EntityTemplate.Id;
            }

            var i, j, entityField, embeddedEntityData, embeddedEntity;
            var entityTemplate = null;

            for (i = 0; i < entityTemplates.length; i++) {
                if (entityTemplates[i].Id === entity.EntityTemplateId) {
                    entityTemplate = entityTemplates[i];
                }
            }

            if (entityTemplate === null) {
                throw 'Could not find entity template ' + entity.EntityTemplateId;
            }

            var entityResult = new Entity();
            entityResult.Id = entity.Id;
            entityResult.EntityTemplateId = entity.EntityTemplateId;
            entityResult.EntityTemplate = entity.EntityTemplate;
            entityResult.LastUpdated = entity.LastUpdated;
            entityResult.PreviewNameText = entity.PreviewNameText;
            entityResult.PreviewDescriptionText = entity.PreviewDescriptionText;
            entityResult.EmailAddress = entity.EmailAddress;

            for (i = 0; i < entityTemplate.Fields.length; i++) {
                var entityTemplateField = entityTemplate.Fields[i];
                entityField = null;

                if (entityTemplateField.FieldType === 'Relationship') {
                    if (entityTemplateField.RelationshipType === 'Embedded' && entityTemplateField.Cardinality === 'Many') {
                        entityResult.Fields.push(convertEmbeddedEntityMany(entityTemplateField, entity));
                    } else if (entityTemplateField.RelationshipType === 'Embedded' && entityTemplateField.Cardinality === 'One') {
                        entityResult.Fields.push(convertEmbeddedEntityOne(entityTemplateField, entity));
                    } else if (entityTemplateField.RelationshipType === 'Linked' && entityTemplateField.Cardinality === 'Many') {
                        entityResult.Fields.push(convertLinkedEntityMany(entityTemplateField, entity));
                    } else if (entityTemplateField.RelationshipType === 'Linked' && entityTemplateField.Cardinality === 'One') {
                        entityResult.Fields.push(convertScalar(entityTemplateField, entity));
                    } else {
                        throw 'Cannot process entity template field with relationship type "' + entityTemplateField.RelationshipType + '" and cardinality "' + entityTemplateField.Cardinality + '"';
                    }
                } else if (entityTemplateField.FieldType === 'Image') {
                    entityResult.Fields.push(convertImage(entityTemplateField, entity));
                } else {
                    entityResult.Fields.push(convertScalar(entityTemplateField, entity));
                }
            }

            function convertEmbeddedEntityMany(entityTemplateField, entity) {
                var entityArray = entity.Fields[entityTemplateField.Name];
                var entityField = new EntityFieldArray(entityTemplateField.Name);

                if (entityArray && entityArray.length) {
                    for (var j = 0; j < entityArray.length; j++) {
                        var embeddedEntityData = {
                            EntityTemplateId: entityTemplateField.EntityTemplateId,
                            Fields: entityArray[j]
                        };
                        var embeddedEntity = convertEntity1toEntity2(embeddedEntityData, entityTemplates);
                        entityField.value.push(new EntityFieldEmbeddedEntity(entityTemplateField.Name, embeddedEntity));
                    }
                }

                return entityField;
            }

            function convertEmbeddedEntityOne(entityTemplateField, entity) {
                var embeddedEntityData = {
                    EntityTemplateId: entityTemplateField.EntityTemplateId,
                    Fields: angular.copy(entity.Fields[entityTemplateField.Name])
                };

                if (embeddedEntityData.Fields === undefined || embeddedEntityData.Fields === null) {
                    embeddedEntityData.Fields = [];
                }

                var embeddedEntity = convertEntity1toEntity2(embeddedEntityData, entityTemplates);
                var entityField = new EntityFieldEmbeddedEntity(entityTemplateField.Name, embeddedEntity);

                return entityField;
            }

            function convertLinkedEntityMany(entityTemplateField, entity) {
                var entityField = new EntityFieldArray(entityTemplateField.Name);
                entityField.fieldInfo = entityTemplateField;

                var linkedEntityArray = entity.Fields[entityTemplateField.Name];

                if (linkedEntityArray && linkedEntityArray.length) {
                    for (var j = 0; j < linkedEntityArray.length; j++) {
                        entityField.value.push(new EntityFieldScalar(entityTemplateField.Name, linkedEntityArray[j]));
                    }
                }

                return entityField;
            }

            function convertImage(entityTemplateField, entity) {
                var entityField = new EntityFieldImage(entityTemplateField.Name, entity.Fields[entityTemplateField.Name]);
                entityField.fieldInfo = entityTemplateField;
                return entityField;
            }

            function convertScalar(entityTemplateField, entity) {
                var entityField = new EntityFieldScalar(entityTemplateField.Name, entity.Fields[entityTemplateField.Name]);
                entityField.fieldInfo = entityTemplateField;
                return entityField;
            }

            return entityResult;
        }

        return Entity;
    }
})();